import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import PrivateRoute from '../routeUtilities/PrivateRoute';
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
  useParams,
  useRouteMatch
} from "react-router-dom";
import '../styles/grid.css';
import {NavSidebar} from './components/NavSidebar';
import _ from 'lodash';
import PropertyTable from './components/PropertyTable';
import PointAnalyticsTable from './components/PointAnalyticsTable';
import PropertyActivityGrid from './components/PropertyActivityGrid';
import InspectionDateSelector from './components/InspectionDateSelector';
import InspectionEquipmentHierarchy from './components/InspectionEquipmentHierarchy';
import { useFilterContext } from "../context/SharedFilterContext";

// Import panel components directly
import UserPanel from './components/UserPanel';
import MetabasePanel from './components/MetabasePanel';
import QueryPanel from './components/QueryPanel';
import ViewServiceTechAtCompanyPanel from './components/ViewServiceTechAtCompanyPanel';
import ViewMSIUsersAggregatePanel from './components/ViewMSIUsersAggregatePanel';
import AnalyticsCountPanel from './components/AnalyticsCountPanel';
import SoundDatabasePanel from './components/SoundDatabasePanel';

const MigrationScreen = (props) => {
  const params = useParams();
  let { path, url } = useRouteMatch();
  const { 
    user,
    isSuperAdmin,
    isCustomerTechOrHigher,
    isLimitedAdminOrHigher,
    isAdminOrHigher,
    isSubdomainAdminOrHigher,
  } = useAuth();
  const {
    selectedProperty,
  } = useFilterContext();

  // State to control which panel view to show
  const [currentView, setCurrentView] = useState('main'); // 'main', 'metabase', 'analytics', 'sound'

  const renderMainPanels = () => (
    <div className="d-flex flex-row">
      <div>
        <div className={`d-flex flex-row flex-wrap justify-content-start`}>
          
          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Company Activity Dashboard"}
              description={"Activity"}
              dest={`/company_activity_report`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Company Admin Dashboard"}
              description={"Admin Dashboard"}
              dest={`/company_admin_dashboard`}
            />
          }

          {((isCustomerTechOrHigher())) &&
            <UserPanel
              title={"Administrator"}
              description={isAdminOrHigher() ? "User Profiles" : "My Profile"}
              dest={`/users`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Property Importer"}
              description={"Importer"}
              dest={`/import`}
              disabled={!(isSuperAdmin() || isSubdomainAdminOrHigher())}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Metrics"}
              description={"Admin Metrics"}
              dest={`/metrics_screen`}
            />
          }

          {(isSuperAdmin()) &&
            <UserPanel
              title={"Company Settings"}
              description={"Manage Company Settings"}
              dest={`/company_settings`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Property Groups"}
              description={"Manage Property Groups"}
              dest={`/property_lists`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) &&
            <UserPanel
              title={"Notifications"}
              description={"Send & View Notifications"}
              dest={`/notifications_screen`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) && user.company?.id === "1121" &&
            <UserPanel
              title={"Work Orders"}
              description={"All Work Orders"}
              dest={`/work_orders_screen`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) && user.company?.id === "1121" &&
            <UserPanel
              title={"Cost Avoidance Calculator"}
              description={"Find Your Savings"}
              dest={`/cost_avoidance_screen`}
            />
          }

          {(isAdminOrHigher() || isSubdomainAdminOrHigher()) && user.company?.id === "1121" &&
            <UserPanel
              title={"Cost Avoidance Metrics"}
              description={"Visualize Your Savings"}
              dest={`/cost_avoidance_metrics_screen`}
            />
          }

          {/* Panel buttons to switch views */}
          {/* <div className="d-flex flex-row flex-wrap justify-content-start mt-3">
            <button 
              className="btn btn-outline-primary m-2"
              onClick={() => setCurrentView('metabase')}
            >
              View Metabase Charts
            </button>
            <button 
              className="btn btn-outline-primary m-2"
              onClick={() => setCurrentView('analytics')}
            >
              View Analytics Count
            </button>
            <button 
              className="btn btn-outline-primary m-2"
              onClick={() => setCurrentView('sound')}
            >
              View Sound Database
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );

  const renderMetabasePanels = () => (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row justify-content-between mb-3">
        <h3>Metabase Analytics</h3>
        <button 
          className="btn btn-secondary"
          onClick={() => setCurrentView('main')}
        >
          Back to Main
        </button>
      </div>
      <div className="d-flex flex-row">
        <div className="property-activity-grid" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <QueryPanel
            title="Total number of service technicians at company"
            description="Click to view the chart"
            ChartComponent={ViewServiceTechAtCompanyPanel}
            style={{ width: '48%', boxSizing: 'border-box' }}
          />

          <QueryPanel
            title="Number of unique users who connected with a MSi150 over time"
            description="Click to view the chart"
            ChartComponent={ViewMSIUsersAggregatePanel}
            style={{ width: '48%', boxSizing: 'border-box' }}
          />
        </div>
      </div>
    </div>
  );

  const renderAnalyticsPanels = () => (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row justify-content-between mb-3">
        <h3>Analytics Count</h3>
        <button 
          className="btn btn-secondary"
          onClick={() => setCurrentView('main')}
        >
          Back to Main
        </button>
      </div>
      <div className="d-flex flex-row">
        <div className={`d-flex flex-row flex-wrap justify-content-start`}>
          <AnalyticsCountPanel
            title={"Analytics Count Figure"}
            description={"Old Platform Count Info Component"}
          />
        </div>
      </div>
    </div>
  );

  const renderSoundDatabasePanels = () => (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row justify-content-between mb-3">
        <h3>Sound Database</h3>
        <button 
          className="btn btn-secondary"
          onClick={() => setCurrentView('main')}
        >
          Back to Main
        </button>
      </div>
      <div className="d-flex flex-row">
        <div className={`d-flex flex-row flex-wrap justify-content-start`}>
          <SoundDatabasePanel
            title={"Sound Database Files"}
            description={"Sound Reference Files"}
          />
        </div>
      </div>
    </div>
  );

  const renderCurrentView = () => {
    switch(currentView) {
      case 'metabase':
        return renderMetabasePanels();
      case 'analytics':
        return renderAnalyticsPanels();
      case 'sound':
        return renderSoundDatabasePanels();
      default:
        return renderMainPanels();
    }
  };

  return (
    <div className="d-flex flex-row justify-content-start align-items-start">
      <NavSidebar/>
      <div className="d-flex flex-column rounded-lg bg-white p-3 mt-2 "  
        style={{width:'87vw', minWidth: '800px'}}
      >
        <Switch>
          <PrivateRoute exact path={`${path}`}>
            <div className="d-flex flex-column">
              <h3>Select an admin page to view</h3>
              {renderCurrentView()}
            </div>
          </PrivateRoute>
        </Switch>
      </div>
    </div>
  );
};

export default MigrationScreen;